import React, {  useMemo, useState } from "react";
import { useSelector } from 'react-redux'
import { Button, Col, Input, Modal, ModalBody, ModalHeader, Row } from 'reactstrap'
import * as  divisaoComissaoActions from '../../../store/modules/divisaoComissao/actions'
import './style.css'

import * as BiIcons from "react-icons/bi";
import { useTable, useSortBy, usePagination } from "react-table";
import * as BsIcons from "react-icons/bs";
import ReactPaginate from "react-paginate";
import { COLUMNS_LOJA } from "../constants/columns"

const TableLoja = ({ items }) => {
    const columns = useMemo(() => COLUMNS_LOJA, []);
    const data = items;
    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        page,
        prepareRow,
        gotoPage,
        state,
        setPageSize,
        rows
    } = useTable({
        columns,
        data
    },
        useSortBy,
        usePagination);

    const {  pageSize } = state;
    const [initialPage, setInitialPage] = useState(false);
    const [selectedPage, setSelectedPage] = useState(null);

    const handlePageClick = (e) => {
        const pageSelected = e.selected;
        setInitialPage(false);
        setSelectedPage(pageSelected);
        gotoPage(pageSelected);
    }

    function handleInitialPage() {
        gotoPage(0);
        setInitialPage(true);
        setSelectedPage(0);
    }

    const { seeRegister } = useSelector(state => state.divisaoComissao)
    const [indexExclusao, setIndexExclusao] = useState(null)

    const toggleModalDelete = () => setIndexExclusao(null)

    function handleDelete() {
        divisaoComissaoActions.removeLoja(indexExclusao)
        setIndexExclusao(null)
    }

    const pageCount = Math.ceil(rows.length / pageSize);
    return (
        <>
            <Modal
                className='text-center'
                isOpen={indexExclusao !== null}
                toggle={toggleModalDelete}
                backdrop={false}
            >
                <ModalHeader toggle={toggleModalDelete} className='divisao-comissao-loja-modal-header' />
                <ModalBody>
                    <p className='divisao-comissao-loja-modal-texto'>Tem certeza que deseja <strong className='divisao-comissao-loja-modal-destaque'>remover</strong> esse item?</p>
                    <p className='divisao-comissao-loja-modal-texto'>Obs: A remoção só será gravada ao salvar o cadastro</p>
                </ModalBody>
                <div className='m-3'>
                    <Button onClick={() => toggleModalDelete()} color='danger' className='divisao-comissao-loja-modal-botao divisao-comissao-loja-modal-cancelar'> Cancelar </Button>
                    <Button onClick={() => handleDelete()} className='divisao-comissao-loja-modal-botao divisao-comissao-loja-modal-confirmar'> Confirmar </Button>
                </div>
            </Modal>
         <table {...getTableProps()}>
                            <thead>
                                {headerGroups.map((headerGroup) => (
                                    <tr {...headerGroup.getHeaderGroupProps()}>
                                        {headerGroup.headers.map((column) => (
                                            <th>
                                                {column.render("Header")}
                                                <span className="float-right">
                                                    {column.isSorted ?
                                                        (column.isSortedDesc ?
                                                            <BsIcons.BsArrowDown
                                                                {...column.getHeaderProps(column.getSortByToggleProps({ title: undefined }))}
                                                            />
                                                            :
                                                            <BsIcons.BsArrowUp
                                                                id="OrdenarAsc"
                                                                {...column.getHeaderProps(column.getSortByToggleProps({ title: undefined }))}
                                                            />)
                                                        :
                                                        <BsIcons.BsArrowDownUp
                                                            {...column.getHeaderProps(column.getSortByToggleProps({ title: undefined }))}
                                                        />}
                                                </span>
                                            </th>
                                        ))}
                                        <th className="divisao-comissao-loja-acoes">
                                            Ações
                                 </th>
                                    </tr>
                                ))}
                            </thead>
                            <tbody {...getTableBodyProps()}>
                                {page.map((row) => {
                                    prepareRow(row)
                                    return (
                                        <tr className="text-center" {...row.getRowProps()}>
                                            {row.cells.map((cell) => {
                                                return (<td {...cell.getCellProps()}>{cell.render("Cell")}</td>)
                                            })}
                                            <td className="divisao-comissao-loja-acoes">
                                                {!seeRegister &&
                                                    <BiIcons.BiTrash
                                                        className="divisao-comissao-loja-lixeira"
                                                        onClick={() => setIndexExclusao(row.index)}
                                                    />
                                                }
                                            </td>
                                        </tr>
                                    );
                                })}
                            </tbody>
                        </table>
                        <Row className="pt-4">
                            <Col>
                            <span className="divisao-comissao-loja-total">Mostrando {page.length} de {items.length}</span>
                            </Col>
                            <Col md={8}>
                                <Row className="float-right">
                                    <ReactPaginate
                                        previousLabel={'<'}
                                        nextLabel={'>'}
                                        breakLabel={'...'}
                                        breakClassName={'break-me'}
                                        initialPage={0}
                                        pageCount={pageCount}
                                        marginPagesDisplayed={2}
                                        pageRangeDisplayed={5}
                                        onPageChange={handlePageClick}
                                        containerClassName={"pagination"}
                                        subContainerClassName={"pages pagination"}
                                        activeClassName={"active"}
                                        forcePage={initialPage ? 0 : selectedPage}
                                    />
                                    <Input
                                        type="select"
                                        className="pageSize"
                                        value={pageSize}
                                        onChange={e => { setPageSize(Number(e.target.value)); handleInitialPage() }}>
                                        {
                                            [10, 25, 100].map(pageSize => (
                                                <option key={pageSize} value={pageSize}>
                                                    {pageSize}
                                                </option>
                                            ))
                                        }
                                    </Input>
                                </Row>
                            </Col>
                        </Row>
          </>
    )
}

export default TableLoja
